module.exports = __webpack_public_path__ + "static/media/tombstone.167b7fff.svg";